module.exports = __webpack_public_path__ + "static/icons/icon-transfers-733df67dcaf0946b1e78cd251c1842e9.svg";